import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Select } from 'antd';
import { ButtonColorType, ButtonVariantType } from 'antd/es/button';
import { FC, useRef, useState } from 'react';

import classes from './AddButton.module.scss';

export interface SelectOption {
  label: string;
  value: string;
}

export interface AddButtonProps {
  text: string;
  color?: ButtonColorType;
  variant?: ButtonVariantType;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  options?: SelectOption[];
  onSelect?: (value: string, option: SelectOption) => void;
  placeholder?: string;
}

export const AddButton: FC<AddButtonProps> = ({
  text,
  color = 'orange',
  variant = 'text',
  onClick,
  loading = false,
  disabled = false,
  className = '',
  options,
  onSelect,
  placeholder = '선택하세요',
}) => {
  const [selectOpen, setSelectOpen] = useState(false);
  const selectRef = useRef<any>(null);

  const handleButtonClick = () => {
    if (options && options.length > 0) {
      setSelectOpen(!selectOpen);
    } else if (onClick) {
      onClick();
    }
  };

  const handleSelect = (value: string, option: SelectOption) => {
    setSelectOpen(false);
    if (onSelect) {
      onSelect(value, option);
    }
  };

  if (options && options.length > 0) {
    return (
      <div className={classes.container}>
        <Button
          variant={variant}
          color={color}
          icon={<PlusCircleOutlined />}
          onClick={handleButtonClick}
          loading={loading}
          disabled={disabled}
          className={`${classes.addButton} ${className}`}
          block>
          {text}
        </Button>
        <Select
          ref={selectRef}
          open={selectOpen}
          onOpenChange={setSelectOpen}
          options={options}
          onSelect={handleSelect}
          placeholder={placeholder}
          className={classes.hiddenSelect}
          style={{ minWidth: 200 }}
        />
      </div>
    );
  }

  return (
    <Button
      variant={variant}
      color={color}
      icon={<PlusCircleOutlined />}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      className={`${classes.addButton} ${className}`}
      block>
      {text}
    </Button>
  );
};
